<template>
    <div class="main" :class="{ 'is-blocked': blockFormClicks }">
        <div class="div_logo">
            <van-image width="70%" :src="require('../../assets/transport/title.svg')" style="top: 10px;"/>
            <p style="color: #6C5141;">——内部收发货平台——</p>
        </div>
        <div class="div_flex" style="margin: -40px 12px 0 12px;height: 40px;">
            <a>我的订单</a>
            <van-button round type="info" size="small" @click="GotoListPage">查看订单</van-button>
        </div>
        <div class="div_card">
            <div style="padding-left: 12px;font-size: 14px;"><van-icon name="youzan-shield" color="#999999"/>3小时内高效转运服务</div>
            <div class="div_flex">
                <div class="div_input" @click="onAddress('发货')">
                    <a class="div_icon" style="background-color: #333333;">发</a>
                    <div class="div_address" :style="{ color: form.DeliveryAddress === '选择发货地点' ? '#999999' : 'black' }">{{ form.DeliveryAddress }}</div>
                    <van-icon name="arrow" v-if="form.DeliveryAddress === '选择发货地点'"/>
                </div>
                <div class="div_split"></div>
                <div class="div_person-info">
                    <div style="font-weight: 600;">{{ form.Name}}<a style="font-size: 14px;padding-left: 4px;">{{ form.Department }}</a></div>
                    <div style="font-size: 14px;">{{ form.Landline }}</div>
                </div>
            </div>
            <div class="div_flex" @click="onAddress('收货')">
                <div class="div_input div_input--full">
                    <a class="div_icon" style="background-color: #FEB013;">收</a>
                    <div class="div_address" :style="{ color: form.ShipAddress === '选择收货地点' ? '#999999' : 'black' }">{{ form.ShipAddress }}</div>
                    <van-icon name="arrow" />
                </div>
            </div>
            <div class="div_flex div_receiver-row" @click.stop="openSelectPersonModal">
                <div class="div_receiver-label">
                    <a class="div_icon" style="background-color: #1989fa;">人</a>
                    <span>收货人</span>
                </div>
                <div class="div_receiver-value">
                    <div v-if="form.Receiver" class="div_receiver-selected">
                        <div class="div_receiver-name">
                            {{ form.Receiver }}
                            <van-tag v-if="isExecutiveReceiver" type="primary" size="mini" style="margin-left: 4px;">管理层</van-tag>
                            <a v-if="form.ReceiverDepartment">{{ form.ReceiverDepartment }}</a>
                        </div>
                        <div class="div_receiver-phone">{{ form.ReceiverLandline || form.ReceiverPhone }}</div>
                    </div>
                    <div v-else class="div_txl">选择收货人<a>通讯录</a></div>
                    <van-icon name="arrow" />
                </div>
            </div>

            <!-- 收货人为高管时的脱敏提示与手动对接电话字段 -->
            <div v-if="isExecutiveReceiver" class="executive-tip-banner">
                <van-icon name="info-o" color="#1989fa" style="margin-right: 6px; margin-top: 2px; flex-shrink: 0;" />
                <span>提示：收货人为管理人员，手机号已自动脱敏保护。如需司机联系现场对接人，可在此处补充对接电话。</span>
            </div>
            <van-field v-if="isExecutiveReceiver" v-model="form.ManualPhone" label="对接电话" placeholder="手动填写对接人手机号(选填)" type="tel" input-align="right" />

            <van-cell title="送货时间" is-link :value="form.DeliveryTime" @click="openTimePicker"/>
            <div style="padding: 10px 12px 0 12px;font-size: 14px;"><van-icon name="checked" />送货时间段为上午12点前或下午4点半前</div>
        </div>
        <div class="div_card">
            <a class="div_input" style="padding: 0 12px;color: #000;">货物名称<a class="div_icon icon_checked">必填</a></a>
            <van-radio-group v-model="form.ItemName" direction="horizontal" class="div_radio">
                <van-radio name="产品">产品</van-radio>
                <van-radio name="空桶">空桶</van-radio>
                <van-radio name="包材">包材</van-radio>
                <van-radio name="其他">其他</van-radio>
            </van-radio-group>
            <van-field v-if="form.ItemName === '其他'" v-model="form.ItemOtherName" label="其他" placeholder="请输入货物名称" input-align="right"/>
            <van-field readonly clickable label="数量" :value="form.ItemNum ? form.ItemNum + ' ' + form.ItemUnit : ''" placeholder="请选择数量和单位" @click="openUnitPicker" input-align="right"/>
            <van-field v-model="form.Remark" label="备注" placeholder="请输入备注信息" input-align="right" rows="1" autosize type="textarea" maxlength="100" show-word-limit/>
            <van-popup v-model="showUnit" round position="bottom" get-container="body">
                <van-picker show-toolbar :columns="unitColumns" @cancel="showUnit = false" @confirm="onUnit" />
            </van-popup>
        </div>
        <div style="margin: 12px;">
            <van-button block round :disabled="btnStatus" color="#FEB013" @click="onSubmit">去下单</van-button>
        </div>
        <van-popup v-model="showAddress" round position="bottom" get-container="body" :close-on-click-overlay="false">
            <van-picker show-toolbar :title="addressTitle" :columns="addressColumns" @cancel="showAddress = false" @confirm="onConfirmAddress"/>
        </van-popup>
        <van-popup v-model="showTimePicker" position="bottom" round get-container="body" :close-on-click-overlay="false">
            <van-picker show-toolbar title="选择送货时间" :columns="timeColumns" @cancel="showTimePicker = false" @confirm="onConfirmTime"/>
        </van-popup>

        <!-- 选择收货人弹窗 (分两步：1. 检索部门 -> 2. 检索人员) -->
        <van-popup
            v-if="personPopupExist"
            v-model="showPerson"
            position="right"
            get-container="body"
            :z-index="3000"
            :lock-scroll="true"
            :close-on-click-overlay="false"
            :style="{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', backgroundColor: '#f7f8fa' }"
            safe-area-inset-top
            safe-area-inset-bottom
            @closed="onPersonPopupClosed"
        >
            <!-- 顶部导航栏 -->
            <van-nav-bar
                :title="searchStep === 1 ? '选择收货部门 (第1步)' : '选择收货人 (第2步)'"
                :left-text="searchStep === 1 ? '关闭' : '上一步'"
                left-arrow
                @click-left="onNavBack"
                style="background-color: #fff;"
            />

            <!-- 步骤指示进度条 -->
            <div class="step-indicator-bar">
                <div class="step-item" :class="{ 'step-active': searchStep === 1, 'step-done': searchStep === 2 }" @click="searchStep = 1">
                    <span class="step-num">1</span>
                    <span class="step-text">选择部门</span>
                </div>
                <div class="step-line" :class="{ 'step-line-active': searchStep === 2 }"></div>
                <div class="step-item" :class="{ 'step-active': searchStep === 2 }">
                    <span class="step-num">2</span>
                    <span class="step-text">{{ selectedDept.name ? selectedDept.name : '选择人员' }}</span>
                </div>
            </div>

            <!-- ===================== 第一步：检索部门 ===================== -->
            <template v-if="searchStep === 1">
                <van-search
                    v-model="deptSearchValue"
                    show-action
                    placeholder="输入部门名称模糊检索 (如: 仓储、制造、研发)"
                    @input="onDeptSearchInput"
                    @search="onDeptSearch"
                    @clear="onClearDeptSearch"
                >
                    <template #action>
                        <div @click="onDeptSearch" style="color: #FEB013; font-weight: 600; padding: 0 4px;">搜索</div>
                    </template>
                </van-search>

                <div class="person-scroll-container">
                    <!-- 部门检索加载中 -->
                    <div v-if="deptLoading" class="search-loading-box">
                        <van-loading vertical size="26px" color="#FEB013">正在检索部门...</van-loading>
                    </div>

                    <!-- 部门搜索结果列表 -->
                    <div v-else-if="deptList && deptList.length" class="dept-card-list">
                        <div
                            v-for="(dept, idx) in deptList"
                            :key="dept.id || idx"
                            class="dept-card"
                            @click="onSelectDepartment(dept)"
                        >
                            <div class="dept-card-left">
                                <van-icon name="cluster-o" color="#FEB013" size="20" style="margin-right: 8px;" />
                                <span class="dept-name">{{ dept.name }}</span>
                            </div>
                            <div class="dept-card-right">
                                <span class="dept-action-text">选择此部门</span>
                                <van-icon name="arrow" color="#FEB013" size="14" />
                            </div>
                        </div>
                    </div>

                    <!-- 搜索无结果 -->
                    <div v-else-if="hasDeptSearched" class="search-empty-box">
                        <van-empty image="search" description="未搜索到相关部门，请缩短关键词重试" />
                    </div>

                    <!-- 初始空白状态 + 常用部门快捷推荐 -->
                    <div v-else class="dept-initial-container">
                        <div class="initial-tip-box">
                            <van-icon name="search" size="40" color="#dcdee0" />
                            <div class="initial-tip-title">第 1 步：检索收货人所在部门</div>
                            <div class="initial-tip-desc">输入部门名称关键字（如“制造”、“仓储”）快速匹配</div>
                        </div>

                        <div class="quick-dept-section">
                            <div class="quick-dept-title">
                                <van-icon name="fire-o" color="#FEB013" style="margin-right: 4px;" />
                                <span>常用部门快捷选择</span>
                            </div>
                            <div class="quick-dept-grid">
                                <div
                                    v-for="(dept, idx) in quickDepartments"
                                    :key="dept.id || idx"
                                    class="quick-dept-badge"
                                    @click="onSelectDepartment(dept)"
                                >
                                    {{ dept.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <!-- ===================== 第二步：在已选部门下检索人员 ===================== -->
            <template v-else-if="searchStep === 2">
                <!-- 当前已选部门提示横幅 -->
                <div class="selected-dept-banner">
                    <div class="dept-banner-left">
                        <van-icon name="passed" color="#07c160" size="16" style="margin-right: 6px;" />
                        <span>已选部门：</span>
                        <strong class="banner-dept-name">{{ selectedDept.name }}</strong>
                    </div>
                    <van-button size="mini" round plain type="info" @click="searchStep = 1">更换部门</van-button>
                </div>

                <!-- 人员搜索栏 -->
                <van-search
                    v-model="personSearchValue"
                    show-action
                    placeholder="输入姓名 / 工号 / 手机号模糊检索"
                    @input="onPersonSearchInput"
                    @search="onPersonSearch"
                    @clear="onClearPersonSearch"
                >
                    <template #action>
                        <div @click="onPersonSearch" style="color: #FEB013; font-weight: 600; padding: 0 4px;">搜索</div>
                    </template>
                </van-search>

                <div class="person-scroll-container">
                    <!-- 人员检索加载中 -->
                    <div v-if="personBtn" class="search-loading-box">
                        <van-loading vertical size="26px" color="#FEB013">正在检索人员数据...</van-loading>
                    </div>

                    <!-- 人员卡片式列表 -->
                    <div v-else-if="personlist && personlist.length" class="person-card-list">
                        <div
                            v-for="(item, key) in personlist"
                            :key="(item.userid || key) + '-' + personListRenderKey"
                            class="receiver-card"
                            :class="{ 'is-selected': form.ReceiverId === item.userid }"
                            @click.stop="onSelectPersonItem(item)"
                        >
                            <div class="card-header">
                                <div class="card-name-group">
                                    <van-icon name="contact" color="#FEB013" size="20" style="margin-right: 6px;" />
                                    <span class="card-name">{{ item.name }}</span>
                                    <span v-if="item.userid" class="card-tag-userid">工号: {{ item.userid }}</span>
                                    <van-tag v-if="item.isExecutive || item.mobileMasked" type="primary" size="mini" round style="margin-left: 6px;">管理层</van-tag>
                                </div>
                                <div class="card-action-badge" :class="{ 'badge-selected': form.ReceiverId === item.userid }">
                                    {{ form.ReceiverId === item.userid ? '确认' : '选择' }}
                                </div>
                            </div>

                            <div class="card-divider"></div>

                            <div class="card-info-grid">
                                <div class="info-item">
                                    <span class="info-label">部&emsp;&emsp;门：</span>
                                    <span class="info-value">{{ item.departmentName || selectedDept.name || item.department || '未设置部门' }}</span>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">联系电话：</span>
                                    <span class="info-value phone-highlight">{{ item.mobile || '暂无手机号' }}</span>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">座&emsp;&emsp;机：</span>
                                    <span class="info-value">{{ item.telephone || '无' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 搜索无匹配结果 -->
                    <div v-else-if="hasPersonSearched" class="search-empty-box">
                        <van-empty image="search" description="未搜索到该部门相关人员" />
                        <div style="text-align: center; margin-top: 10px;">
                            <van-button size="small" round plain color="#FEB013" @click="loadAllUsersInDept">加载该部门全部人员</van-button>
                        </div>
                    </div>

                    <!-- 初始状态（搜索前内容为空白提示） -->
                    <div v-else class="search-initial-box">
                        <van-icon name="friends-o" size="48" color="#dcdee0" />
                        <div class="initial-tip-title">输入姓名或工号进行模糊检索</div>
                        <div class="initial-tip-desc">在【{{ selectedDept.name }}】中输入姓名即可快速检索</div>
                        <div style="margin-top: 20px;">
                            <van-button size="small" round plain color="#FEB013" @click="loadAllUsersInDept">查看该部门全部人员</van-button>
                        </div>
                    </div>
                </div>
            </template>
        </van-popup>
    </div>
</template>

<script>
const DEFAULT_QUICK_DEPARTMENTS = [
    { id: 2583, name: '仓储物流部' },
    { id: 676, name: '制造一部' },
    { id: 2509, name: '制造二部' },
    { id: 1560, name: '生产管理部' },
    { id: 3287, name: '设备部' },
    { id: 2517, name: '质量检测部' },
    { id: 3638, name: '精益技术部' },
    { id: 3545, name: '医疗设备' },
    { id: 3284, name: '健力' },
    { id: 2503, name: '血液净化' },
    { id: 3296, name: '材料与柱体研究部' },
    { id: 3294, name: '重症产品研发部' },
    { id: 2239, name: '临床部' }
]

// 经理级及以上职位关键词（包括主管、经理、总监、总裁、总经理、副总、主任、部长、厂长、董事、主席、院长、处长、负责人、合伙人、CEO等）
const EXECUTIVE_POSITION_KEYWORDS = [
    '经理', '主管', '总监', '总裁', '总经理', '副总', '主任', '部长', '厂长', '董事', '主席',
    '院长', '处长', '负责人', '合伙人', '董秘', '秘书长', '行长', '首席',
    'CEO', 'CFO', 'CTO', 'COO', 'CMO', 'CIO', 'CHO', 'VP', 'SVP', 'EVP', 'GM', 'MD',
    'Director', 'Manager', 'President', 'Leader', 'Executive', 'Supervisor', 'Head'
]

// 高管/管理层部门关键词（包含高管、董事、总裁办等部门的所有人员均属于管理层）
const EXECUTIVE_DEPARTMENT_KEYWORDS = [
    '高管', '董事', '总裁', '总经办', '领导', '决策', '管理层', '董秘'
]

function maskMobilePhone(mobile) {
    if (!mobile || typeof mobile !== 'string') return mobile || ''
    const trimmed = mobile.trim()
    if (!trimmed) return ''
    if (trimmed.includes('*')) return trimmed
    if (trimmed.length === 11) {
        return trimmed.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
    }
    if (trimmed.length > 7) {
        return trimmed.slice(0, 3) + '****' + trimmed.slice(-4)
    }
    if (trimmed.length > 3) {
        return trimmed.slice(0, 3) + '****'
    }
    return trimmed
}

function isExecutiveOrManager(item, deptName = '', oaUser = null) {
    if (!item && !oaUser) return false
    if (item && (item.isExecutive || item.mobileMasked)) return true

    if (item && (item.is_leader === 1 || item.isleader === 1 || (Array.isArray(item.is_leader_in_dept) && item.is_leader_in_dept.some(l => Number(l) === 1)))) {
        return true
    }

    const pos = (item && item.position ? String(item.position) : '').toLowerCase()
    if (pos && EXECUTIVE_POSITION_KEYWORDS.some(kw => pos.includes(kw.toLowerCase()))) {
        return true
    }

    const allDepts = [
        deptName,
        item && item.departmentName,
        item && (typeof item.department === 'string' ? item.department : ''),
        oaUser && oaUser.departmentname
    ].filter(Boolean).join(' ').toLowerCase()

    if (allDepts && EXECUTIVE_DEPARTMENT_KEYWORDS.some(kw => allDepts.includes(kw.toLowerCase()))) {
        return true
    }
    if (allDepts && ['总裁', '董事', '高管', '总经办'].some(k => allDepts.includes(k))) {
        return true
    }

    if (oaUser && typeof oaUser === 'object') {
        const oaTitles = [
            oaUser.jobtitlename,
            oaUser.jobname,
            oaUser.jobactivitydesc,
            oaUser.duty,
            oaUser.position
        ].filter(Boolean).join(' ').toLowerCase()
        if (oaTitles && EXECUTIVE_POSITION_KEYWORDS.some(kw => oaTitles.includes(kw.toLowerCase()))) {
            return true
        }
    }
    return false
}

export default {
    data() {
        return {
            WXInfo: {},
            DriverList: [],
            isExecutiveReceiver: false,
            form: {
                Name: '',      // 姓名
                UserId: '',    // 工号
                Department: '', // 部门
                Phone: '',     // 手机号
                Landline: '',  // 座机
                ItemName: '',  // 货物名称
                ItemOtherName: '', // 其他货物名称
                ItemNum: 0,     // 货物数量
                ItemUnit: '', // 货物单位
                DeliveryAddress: '选择发货地点',    // 发货地点
                ShipAddress: '选择收货地点',    // 收货地点
                DeliveryTime: '选择时间段',     // 送货时间
                Receiver: '',  // 收货人
                ReceiverId: '', // 收货人工号
                ReceiverDepartment: '', // 收货人部门
                ReceiverPhone: '', // 收货人手机号
                ReceiverLandline: '', // 收货人座机
                ManualPhone: '', // 对接电话 (高管收货人选填)
                Status: '待接单', // 订单状态
                Remark: '' // 备注
            },
            addressTitle: '',
            showAddress: false,
            addressHeight: window.innerHeight > 677 ? '35%' : '45%',
            addressColumns: [
                {
                    text: '健帆园南区',
                    disabled: false,
                    children: [
                        { text: '研发楼东边' },
                        { text: '车间转货平台' },
                        { text: '仓储物流仓库门口' },
                        { text: '化学仓库门口' }
                    ]
                },
                {
                    text: '健帆园北区',
                    disabled: false,
                    children: [
                        { text: '卸货平台' }
                    ]
                },
                {
                    text: '金鼎园区',
                    disabled: false,
                    children: [
                        { text: '仓储物流仓库卸货平台' },
                        { text: '灌流器总厂卸货平台' },
                        { text: '化学仓库门口' }
                    ]
                }
            ],
            showTimePicker: false,
            timeColumns: [
                {
                    text: '',
                    disabled: false,
                    children: [
                        { text: '09:00', disabled: false },
                        { text: '09:30', disabled: false },
                        { text: '10:00', disabled: false },
                        { text: '10:30', disabled: false },
                        { text: '11:00', disabled: false },
                        { text: '11:30', disabled: false },
                        { text: '12:00', disabled: false },
                        { text: '13:30', disabled: false },
                        { text: '14:00', disabled: false },
                        { text: '14:30', disabled: false },
                        { text: '15:00', disabled: false },
                        { text: '15:30', disabled: false },
                        { text: '16:00', disabled: false }
                    ]
                },
                {
                    text: '',
                    children: [
                        { text: '09:00', disabled: false },
                        { text: '09:30', disabled: false },
                        { text: '10:00', disabled: false },
                        { text: '10:30', disabled: false },
                        { text: '11:00', disabled: false },
                        { text: '11:30', disabled: false },
                        { text: '12:00', disabled: false },
                        { text: '13:30', disabled: false },
                        { text: '14:00', disabled: false },
                        { text: '14:30', disabled: false },
                        { text: '15:00', disabled: false },
                        { text: '15:30', disabled: false },
                        { text: '16:00', disabled: false }
                    ]
                }
            ],

            // 两步检索收货人状态
            showPerson: false,
            searchStep: 1, // 1: 检索部门, 2: 检索人员
            selectedDept: { id: null, name: '' },
            
            // 部门检索数据
            deptSearchValue: '',
            deptSearchTimer: null,
            deptLoading: false,
            hasDeptSearched: false,
            deptList: [],
            allDepartments: [],
            quickDepartments: [...DEFAULT_QUICK_DEPARTMENTS],

            // 人员检索数据
            personSearchValue: '',
            personSearchTimer: null,
            personSearchReqId: 0,
            personBtn: false,
            hasPersonSearched: false,
            personlist: [],
            personListRenderKey: 0,
            personPopupExist: false,
            personSelecting: false,
            closingPersonPopup: false,
            blockFormClicks: false,
            personGuardTimer: null,

            btnStatus: false,
            showUnit: false,
            unitColumns: [
                {
                    values: []
                },
                {
                    values: ['板', '个', '桶', '箱', '车']
                }
            ]
        }
    },
    async created() {
        const userInfo = localStorage.getItem('userinfo')
        if (userInfo) {
            try {
                this.WXInfo = JSON.parse(userInfo).data || {}
            } catch (e) {
                this.WXInfo = {}
            }
        }
        // 拼装日期和星期
        let zw = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
        this.timeColumns[0].text = [ this.$moment().format('MM.DD') + ' ' + zw[this.$moment().day()] ]
        this.timeColumns[1].text = [ this.$moment().add(1, 'days').format('MM.DD') + ' ' + zw[this.$moment().add(1, 'days').day()] ]

        if (this.$moment().format('HH:mm') > '08:40' && this.$moment().format('HH:mm') <= '12:00') {
            this.timeColumns[0].children.forEach(item => {
                if (item.text <= '12:00') {
                    item.disabled = true
                }
            })
        } else if (this.$moment().format('HH:mm') > '12:00') {
            this.timeColumns[0].disabled = true
        }
        for (let i = 1; i <= 100; i++) {
            this.unitColumns[0].values.push(i)
        }
    },
    async mounted() {
        this.form.Name = this.WXInfo.name || ''
        this.form.UserId = this.WXInfo.userid || ''
        this.form.Phone = this.WXInfo.mobile || ''
        if (this.WXInfo.name === '王海苑') {
            this.$router.push('/transport/driver')
            return
        }
        await this.init()
    },
    beforeDestroy() {
        if (this.deptSearchTimer) {
            clearTimeout(this.deptSearchTimer)
            this.deptSearchTimer = null
        }
        if (this.personSearchTimer) {
            clearTimeout(this.personSearchTimer)
            this.personSearchTimer = null
        }
        this.personSearchReqId++
        if (this.personGuardTimer) {
            clearTimeout(this.personGuardTimer)
            this.personGuardTimer = null
        }
    },
    methods: {
        async init() {
            // 获取车队人员列表 (用于转发通知和判断司机角色)
            let userlist = await this.getQWUserList(3209)
            if (Array.isArray(userlist)) {
                userlist.forEach(item => {
                    if (item.name === this.form.Name) {
                        this.$router.push('/transport/driver')
                    } else {
                        let data = {
                            name: item.name,
                            userid: item.userid
                        }
                        this.DriverList.push(data)
                    }
                })
            }
            if (this.form.UserId) {
                let res = await this.getUserInfo(this.form.UserId)
                if (res) {
                    this.form.Department = res.departmentname || ''
                    this.form.Landline = res.telephone || ''
                }
            }
            // 预加载部门列表
            this.loadAllDepartments()
        },
        async loadAllDepartments() {
            try {
                const result = await this.$request({
                    url: this.$api.getDepartmentList || '/api/WXAuthorize/getDepartmentList',
                    method: 'GET'
                })
                if (result && result.success && Array.isArray(result.data) && result.data.length > 0) {
                    const filtered = result.data.filter(item => item.id !== 1 && item.parentid !== 0)
                    this.allDepartments = filtered.length > 0 ? filtered : result.data
                }
            } catch (e) {
                this.allDepartments = []
            }
        },
        armFormClickGuard(ms = 500) {
            this.blockFormClicks = true
            this.closingPersonPopup = true
            if (this.personGuardTimer) {
                clearTimeout(this.personGuardTimer)
            }
            this.personGuardTimer = setTimeout(() => {
                this.blockFormClicks = false
                this.closingPersonPopup = false
                this.personSelecting = false
                this.personGuardTimer = null
            }, ms)
        },
        openSelectPersonModal() {
            if (this.closingPersonPopup || this.blockFormClicks) return
            this.personSelecting = false
            this.closingPersonPopup = false
            this.showAddress = false
            this.showTimePicker = false
            this.showUnit = false
            this.personListRenderKey += 1
            if (!this.selectedDept.id) {
                this.searchStep = 1
            }
            if (!this.allDepartments.length) {
                this.loadAllDepartments()
            }
            this.personPopupExist = true
            this.$nextTick(() => {
                this.showPerson = true
            })
        },
        closePersonPopup() {
            this.closingPersonPopup = true
            this.armFormClickGuard(800)
            this.showPerson = false
        },
        onPersonPopupClosed() {
            this.showPerson = false
            this.personPopupExist = false
            this.personSelecting = false
            this.armFormClickGuard(500)
        },
        openTimePicker() {
            if (this.showPerson || this.personSelecting || this.blockFormClicks) return
            this.showTimePicker = true
        },
        openUnitPicker() {
            if (this.showPerson || this.personSelecting || this.blockFormClicks) return
            this.showUnit = true
        },
        onNavBack() {
            if (this.searchStep === 2) {
                this.personSearchReqId++
                this.searchStep = 1
            } else {
                this.personSearchReqId++
                this.closePersonPopup()
            }
        },

        // ================= 第 1 步：检索部门 =================
        onDeptSearchInput(val) {
            if (this.deptSearchTimer) {
                clearTimeout(this.deptSearchTimer)
            }
            const keyword = (val || '').trim()
            if (!keyword) {
                this.deptList = []
                this.hasDeptSearched = false
                this.deptLoading = false
                return
            }
            this.deptSearchTimer = setTimeout(() => {
                this.onDeptSearch()
            }, 300)
        },
        onClearDeptSearch() {
            if (this.deptSearchTimer) {
                clearTimeout(this.deptSearchTimer)
            }
            this.deptSearchValue = ''
            this.deptList = []
            this.hasDeptSearched = false
            this.deptLoading = false
        },
        async onDeptSearch() {
            const keyword = (this.deptSearchValue || '').trim()
            if (!keyword) {
                this.deptList = []
                this.hasDeptSearched = false
                this.deptLoading = false
                return
            }
            this.deptLoading = true
            this.hasDeptSearched = true

            // 先在本地已加载的部门列表中秒级模糊检索
            if (this.allDepartments && this.allDepartments.length > 0) {
                const kw = keyword.toLowerCase()
                this.deptList = this.allDepartments.filter(d => d && d.name && d.name.toLowerCase().includes(kw))
                this.deptLoading = false
                return
            }

            // 本地无数据时调用后端搜索接口
            try {
                const result = await this.$request({
                    url: this.$api.getDepartmentList || '/api/WXAuthorize/getDepartmentList',
                    method: 'GET',
                    params: { keyword: keyword }
                })
                if (result && result.success && Array.isArray(result.data)) {
                    this.deptList = result.data.filter(item => item.id !== 1)
                } else {
                    this.deptList = []
                }
            } catch (e) {
                this.deptList = []
            } finally {
                this.deptLoading = false
            }
        },
        onSelectDepartment(dept) {
            if (!dept || !dept.id) return
            this.personSearchReqId++
            this.selectedDept = { id: dept.id, name: dept.name }
            this.searchStep = 2
            this.personSearchValue = ''
            this.personlist = []
            this.hasPersonSearched = false
        },

        // ================= 第 2 步：检索人员 =================
        onPersonSearchInput(val) {
            if (this.personSearchTimer) {
                clearTimeout(this.personSearchTimer)
            }
            const keyword = (val || '').trim()
            if (!keyword) {
                this.personSearchReqId++
                this.personlist = []
                this.hasPersonSearched = false
                this.personBtn = false
                return
            }
            this.personSearchTimer = setTimeout(() => {
                this.onPersonSearch()
            }, 350)
        },
        onClearPersonSearch() {
            if (this.personSearchTimer) {
                clearTimeout(this.personSearchTimer)
            }
            this.personSearchReqId++
            this.personSearchValue = ''
            this.personlist = []
            this.hasPersonSearched = false
            this.personBtn = false
        },
        async onPersonSearch() {
            const keyword = (this.personSearchValue || '').trim()
            if (!keyword) {
                this.personlist = []
                this.hasPersonSearched = false
                this.personBtn = false
                return
            }
            if (!this.selectedDept.id) {
                this.$toast('请先选择所在部门')
                this.searchStep = 1
                return
            }
            this.personBtn = true
            this.hasPersonSearched = true
            // 搜索请求递增 request id，只接受最新一次返回结果，避免乱序覆盖
            const reqId = (this.personSearchReqId = (this.personSearchReqId || 0) + 1)
            try {
                const result = await this.$request({
                    url: this.$api.getDepartmentUserbyQW || '/api/WXAuthorize/getDepartmentUserbyQW',
                    method: 'GET',
                    params: {
                        id: this.selectedDept.id,
                        fetch_child: 1,
                        keyword: keyword
                    }
                })
                if (reqId !== this.personSearchReqId) return
                if (result && result.success && Array.isArray(result.data)) {
                    this.personlist = result.data.map(u => {
                        const isExec = isExecutiveOrManager(u, this.selectedDept.name)
                        if (isExec) {
                            u.isExecutive = true
                            u.mobileMasked = true
                            u.mobile = maskMobilePhone(u.mobile)
                        }
                        return u
                    })
                    this.fillOAUserTelephones(this.personlist)
                } else {
                    if (result && result.message) {
                        this.$toast(result.message)
                    }
                    this.personlist = []
                }
            } catch (e) {
                if (reqId !== this.personSearchReqId) return
                this.personlist = []
            } finally {
                if (reqId === this.personSearchReqId) {
                    this.personBtn = false
                }
            }
        },
        async loadAllUsersInDept() {
            if (!this.selectedDept.id) return
            this.personBtn = true
            this.hasPersonSearched = true
            const reqId = (this.personSearchReqId = (this.personSearchReqId || 0) + 1)
            try {
                const result = await this.$request({
                    url: this.$api.getDepartmentUserbyQW || '/api/WXAuthorize/getDepartmentUserbyQW',
                    method: 'GET',
                    params: {
                        id: this.selectedDept.id,
                        fetch_child: 1
                    }
                })
                if (reqId !== this.personSearchReqId) return
                if (result && result.success && Array.isArray(result.data)) {
                    this.personlist = result.data.map(u => {
                        const isExec = isExecutiveOrManager(u, this.selectedDept.name)
                        if (isExec) {
                            u.isExecutive = true
                            u.mobileMasked = true
                            u.mobile = maskMobilePhone(u.mobile)
                        }
                        return u
                    })
                    this.fillOAUserTelephones(this.personlist)
                } else {
                    this.personlist = []
                }
            } catch (e) {
                if (reqId !== this.personSearchReqId) return
                this.personlist = []
            } finally {
                if (reqId === this.personSearchReqId) {
                    this.personBtn = false
                }
            }
        },
        fillOAUserTelephones(list) {
            if (!Array.isArray(list) || !list.length) return
            list.forEach(async (item) => {
                if (item && item.userid) {
                    const oaInfo = await this.getUserInfo(item.userid)
                    if (oaInfo) {
                        if (oaInfo.telephone) {
                            this.$set(item, 'telephone', oaInfo.telephone)
                        }
                        if (oaInfo.departmentname) {
                            this.$set(item, 'departmentName', oaInfo.departmentname)
                        }
                        if (!item.isExecutive && isExecutiveOrManager(item, item.departmentName || this.selectedDept.name, oaInfo)) {
                            this.$set(item, 'isExecutive', true)
                            this.$set(item, 'mobileMasked', true)
                            this.$set(item, 'mobile', maskMobilePhone(item.mobile))
                        }
                    }
                }
            })
        },
        onSelectPersonItem(item) {
            if (!item || this.closingPersonPopup) return
            this.personSelecting = true
            this.showTimePicker = false
            this.showAddress = false
            this.showUnit = false

            const isExec = isExecutiveOrManager(item, this.selectedDept.name)
            this.form.Receiver = item.name || ''
            this.form.ReceiverId = item.userid || ''
            this.form.ReceiverPhone = (item.mobileMasked || isExec) ? maskMobilePhone(item.mobile) : (item.mobile || '')
            this.form.ReceiverDepartment = item.departmentName || this.selectedDept.name || (Array.isArray(item.department) ? item.department.join('/') : (item.department || ''))
            this.form.ReceiverLandline = item.telephone || ''
            this.isExecutiveReceiver = isExec || !!item.mobileMasked
            if (!this.isExecutiveReceiver) {
                this.form.ManualPhone = ''
            }

            this.$toast('已选择收货人：' + item.name)
            this.closePersonPopup()
            this.refreshReceiverFromOA(item)
        },
        async refreshReceiverFromOA(item) {
            if (!item || !item.userid) return
            const selectedId = item.userid
            const oaInfo = await this.getUserInfo(selectedId)
            if (!oaInfo || this.form.ReceiverId !== selectedId) return
            if (oaInfo.telephone) {
                this.form.ReceiverLandline = oaInfo.telephone
            }
            if (oaInfo.departmentname) {
                this.form.ReceiverDepartment = oaInfo.departmentname
            }
            if (!this.isExecutiveReceiver && isExecutiveOrManager(item, this.form.ReceiverDepartment, oaInfo)) {
                this.isExecutiveReceiver = true
                this.form.ReceiverPhone = maskMobilePhone(this.form.ReceiverPhone)
            }
        },

        sendMessage(id) {
            let receiverInfo = this.form.Receiver
            if (this.isExecutiveReceiver && this.form.ManualPhone && this.form.ManualPhone.trim()) {
                receiverInfo += ` (对接电话: ${this.form.ManualPhone.trim()})`
            }
            let driverMessage = '转货任务通知：' +
                '\n\n送货时间：' + this.form.DeliveryTime +
                '\n发货人：' + this.form.Name +
                '\n收货人：' + receiverInfo +
                '\n货物：' + (this.form.ItemName === '其他' ? this.form.ItemOtherName : this.form.ItemName) +
                '\n数量：' + this.form.ItemNum + this.form.ItemUnit +
                '\n发货地点：' + this.form.DeliveryAddress +
                '\n收货地点：' + this.form.ShipAddress +
                '\n\n您收到一个转货任务，请及时处理。\n\n' +
                '<a href="https://pinche.jafron.com/transport/detail?role=driver&id='+ id +'">查看详情</a>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;' +
                '<a href="https://pinche.jafron.com/transport/index">转货列表</a>'
            this.DriverList.forEach(item => {
                this.postSendMessage(item.userid, driverMessage)
            })
        },
        GotoListPage() {
            this.$router.push('/transport/list?role=sponsor')
        },
        onAddress(type) {
            if (this.showPerson || this.personSelecting || this.blockFormClicks) return
            this.addressType = type
            this.addressTitle = '选择' + type + '地点'
            this.showAddress = true
        },
        onConfirmTime(value) {
            this.form.DeliveryTime = value[0] + ' ' + value[1]
            this.showTimePicker = false
        },
        onConfirmAddress(value) {
            if (this.addressType === '发货') {
                this.form.DeliveryAddress = value[0] + ' ' + value[1]
            } else {
                this.form.ShipAddress = value[0] + ' ' + value[1]
            }
            this.showAddress = false
        },
        onUnit(value) {
            this.form.ItemNum = value[0]
            this.form.ItemUnit = value[1]
            this.showUnit = false
        },
        async getUserInfo(data) {
            try {
                const result = await this.$request({
                    url: '/api/tokenOA/getOAUserInfo',
                    method: 'GET',
                    params: {
                        UserId: data
                    }
                })
                if (result && result.success && Array.isArray(result.data) && result.data.length > 0) {
                    return result.data[0]
                }
            } catch (e) {
                console.error(e)
            }
            return {}
        },
        async getQWUserList(id) {
            try {
                const result = await this.$request({
                    url: this.$api.getDepartmentUserbyQW || '/api/WXAuthorize/getDepartmentUserbyQW',
                    method: 'GET',
                    params: { id: id }
                })
                if (result && result.success && Array.isArray(result.data)) {
                    return result.data
                } else {
                    if (result && result.message) {
                        this.$toast(result.message)
                    }
                    return []
                }
            } catch (e) {
                return []
            }
        },
        getSubmitTip() {
            if (this.form.DeliveryAddress === '选择发货地点') return '请选择发货地点'
            if (this.form.ShipAddress === '选择收货地点') return '请选择收货地点'
            if (!this.form.ReceiverId) return '请选择收货人'
            if (this.form.DeliveryTime === '选择时间段') return '请选择送货时间'
            if (!this.form.ItemName) return '请选择货物名称'
            if (this.form.ItemName === '其他' && !(this.form.ItemOtherName || '').trim()) return '请输入货物名称'
            if (!this.form.ItemNum || !this.form.ItemUnit) return '请选择数量和单位'
            return ''
        },
        async onSubmit() {
            const tip = this.getSubmitTip()
            if (tip) {
                this.$toast(tip)
                return
            }
            this.btnStatus = true
            const postData = { ...this.form }
            if (this.isExecutiveReceiver && this.form.ManualPhone && this.form.ManualPhone.trim()) {
                postData.ReceiverPhone = this.form.ManualPhone.trim()
            }
            postData.ItemName = this.form.ItemName === '其他'
                ? this.form.ItemOtherName.trim()
                : this.form.ItemName
            delete postData.ItemOtherName

            let submitted = false
            try {
                const result = await this.$request({
                    url: '/api/GeneralMethod/postFunctionSave',
                    method: 'POST',
                    params: { Name: 'transport' },
                    data: postData
                })
                if (result && result.success && result.data && result.data._id) {
                    submitted = true
                    this.$toast('提交成功')
                    this.sendMessage(result.data._id)
                    this.$router.push('/transport/detail?id=' + result.data._id + '&role=sponsor')
                    return
                }
                this.$toast((result && result.message) || '提交失败，请稍后重试')
            } catch (e) {
                this.$toast('提交失败，请稍后重试')
            } finally {
                if (!submitted) {
                    this.btnStatus = false
                }
            }
        },
        async postSendMessage(userid, message) {
            const result = await this.$request({
                url: this.$api.postSendMessageWX,
                method: 'POST',
                data: {
                    'touser': userid,
                    'msgtype': 'text',
                    'agentid': this.$agentid,
                    'text': { 'content': message }
                }
            })
            if (!result || !result.success) {
                if (result && result.message) {
                    this.$toast(result.message)
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>
.main {
    height: inherit;
}
.main.is-blocked {
    pointer-events: none;
}
.div_logo {
    background: #FEB013;
    background-image: url('../../assets/transport/person.svg');
    background-repeat: no-repeat;
    background-position: right;
    background-size: 120px;
    color: white;
    text-align: left;
    box-shadow: 0px 3px 12px 0px rgba(252, 113, 39, 0.30);
    padding: 12px;
    font-size: 14px;
    height: 100px;
}
.div_flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 12px;
    margin: 5px 0;
    height: 50px;
    overflow: hidden;
    background-color: #FFFFFF;
    border-bottom: 1px solid #F5F5F5;
    border-radius: 10px;
}
.div_split {
    border-left: 1px solid #9999;
    height: 20px;
    margin: 0 8px;
    flex-shrink: 0;
}
.div_card {
    background-color: #FFFFFF;
    border-radius: 10px;
    padding: 12px 0;
    margin: 10px 12px;
    color: #6C5141;
}
.div_input {
    display: flex;
    align-items: center;
    font-weight: 600;
    color: #999999;
    width: 50%;
    min-width: 0;
    overflow: hidden;
    flex: 1;
}
.div_input--full {
    width: 100%;
}
.div_person-info {
    flex: 1;
    min-width: 0;
    text-align: center;
    overflow: hidden;
}
.div_icon {
    font-size: 14px;
    font-weight: normal;
    color: #FFFFFF;
    border-radius: 50%;
    min-width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
}
.div_radio {
    padding: 20px 12px;
    justify-content: center;
    border-bottom: 1px solid #F5F5F5;
    margin: 0 10px;
}
.icon_checked {
    color: red;
    background-color: #F5F5F5;
    width: 40px;
    font-size: 12px;
    border-radius: 10px;
    margin-left: 8px;
}
.div_txl{
    display: flex;
    align-items: center;
    color: #969799;
    a {
        font-size: 12px;
        color: #1989fa;
        margin-left: 6px;
    }
}
.div_address {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: normal;
    text-align: left;
    font-size: 13px;
}
.div_receiver-row {
    position: relative;
    z-index: 1;
    height: auto;
    min-height: 50px;
}
.div_receiver-label {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    font-weight: 600;
    color: #323233;
    margin-right: 8px;
}
.div_receiver-value {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1;
    min-width: 0;
    overflow: hidden;
}
.div_receiver-selected {
    flex: 1;
    min-width: 0;
    text-align: right;
    margin-right: 4px;
    overflow: hidden;
}
.div_receiver-name {
    font-weight: 600;
    color: #323233;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    a {
        font-size: 14px;
        padding-left: 4px;
        font-weight: 400;
        color: #646566;
    }
}
.div_receiver-phone {
    font-size: 14px;
    color: #646566;
}
.executive-tip-banner {
    background-color: #ecf5ff;
    color: #409eff;
    font-size: 12px;
    line-height: 1.5;
    padding: 8px 12px;
    margin: 8px 12px;
    border-radius: 6px;
    display: flex;
    align-items: flex-start;
}

/* 步骤指示栏 */
.step-indicator-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    padding: 8px 16px;
    border-bottom: 1px solid #f2f3f5;
}

.step-item {
    display: flex;
    align-items: center;
    cursor: pointer;
    opacity: 0.6;
    transition: all 0.2s ease;

    .step-num {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background-color: #909399;
        color: #fff;
        font-size: 11px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 6px;
    }
    .step-text {
        font-size: 13px;
        font-weight: 500;
        color: #606266;
    }

    &.step-active {
        opacity: 1;
        .step-num {
            background-color: #FEB013;
        }
        .step-text {
            color: #323233;
            font-weight: 700;
        }
    }

    &.step-done {
        opacity: 0.9;
        .step-num {
            background-color: #07c160;
        }
    }
}

.step-line {
    width: 36px;
    height: 2px;
    background-color: #e4e7ed;
    margin: 0 10px;

    &.step-line-active {
        background-color: #FEB013;
    }
}

/* 已选部门提示条 */
.selected-dept-banner {
    background-color: #f0f9eb;
    border-bottom: 1px solid #e1f3d8;
    padding: 8px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    color: #67c23a;

    .dept-banner-left {
        display: flex;
        align-items: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .banner-dept-name {
        color: #303133;
        font-size: 14px;
    }
}

/* 部门卡片列表 */
.dept-card-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.dept-card {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 14px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);
    cursor: pointer;
    transition: all 0.2s;

    &:active {
        background-color: #f7f8fa;
    }

    .dept-card-left {
        display: flex;
        align-items: center;
        flex: 1;
        min-width: 0;
    }
    .dept-name {
        font-size: 15px;
        font-weight: 600;
        color: #323233;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .dept-card-right {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        margin-left: 8px;
    }
    .dept-action-text {
        font-size: 12px;
        color: #FEB013;
        font-weight: 500;
        margin-right: 4px;
    }
}

/* 部门初始界面与快捷推荐 */
.dept-initial-container {
    display: flex;
    flex-direction: column;
}

.initial-tip-box {
    text-align: center;
    padding: 30px 16px 20px 16px;
    color: #909399;

    .initial-tip-title {
        margin-top: 12px;
        font-size: 15px;
        font-weight: 600;
        color: #323233;
    }
    .initial-tip-desc {
        margin-top: 6px;
        font-size: 12px;
        color: #909399;
    }
}

.quick-dept-section {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 14px 16px;
    margin-top: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);

    .quick-dept-title {
        display: flex;
        align-items: center;
        font-size: 13px;
        font-weight: 600;
        color: #606266;
        margin-bottom: 12px;
    }

    .quick-dept-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .quick-dept-badge {
        background-color: #f7f8fa;
        color: #323233;
        font-size: 13px;
        padding: 6px 12px;
        border-radius: 6px;
        border: 1px solid #ebedf0;
        cursor: pointer;
        transition: all 0.2s;

        &:active {
            background-color: rgba(254, 176, 19, 0.1);
            border-color: #FEB013;
            color: #FEB013;
        }
    }
}

/* 人员卡片与容器样式 */
.person-scroll-container {
    flex: 1;
    overflow-y: auto;
    padding: 8px 12px 24px 12px;
    box-sizing: border-box;
}

.search-loading-box {
    padding-top: 60px;
    text-align: center;
}

.search-empty-box {
    padding-top: 30px;
}

.search-initial-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 60px;
    color: #969799;
    text-align: center;
    .initial-tip-title {
        margin-top: 16px;
        font-size: 15px;
        font-weight: 600;
        color: #323233;
    }
    .initial-tip-desc {
        margin-top: 8px;
        font-size: 12px;
        color: #969799;
    }
}

.person-card-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.receiver-card {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 12px 14px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    border: 1.5px solid transparent;
    transition: all 0.2s ease;
    cursor: pointer;

    &:active {
        background-color: #fafafa;
    }

    &.is-selected {
        border-color: #FEB013;
        background-color: rgba(254, 176, 19, 0.03);
    }
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card-name-group {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
}

.card-name {
    font-size: 16px;
    font-weight: 700;
    color: #323233;
}

.card-tag-userid {
    font-size: 11px;
    color: #909399;
    background-color: #f2f3f5;
    padding: 1px 6px;
    border-radius: 4px;
    margin-left: 4px;
}

.card-action-badge {
    font-size: 12px;
    padding: 3px 10px;
    border-radius: 999px;
    background-color: #f2f3f5;
    color: #606266;
    font-weight: 500;

    &.badge-selected {
        background-color: #FEB013;
        color: #ffffff;
    }
}

.card-divider {
    height: 1px;
    background-color: #f5f6f7;
    margin: 8px 0;
}

.card-info-grid {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.info-item {
    display: flex;
    font-size: 13px;
    line-height: 1.4;
}

.info-label {
    color: #909399;
    flex-shrink: 0;
    width: 72px;
}

.info-value {
    color: #4b5563;
    flex: 1;
    word-break: break-all;

    &.phone-highlight {
        color: #1f2937;
        font-weight: 600;
    }
}
</style>
